import type { ReactNode } from 'react';

export const symbol_ev_shadow_minus: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M610-210q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h240q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H610ZM464-80q-76 0-144.5-31.5T197-197q-57-57-87-130T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q79.46 0 149.25 28.27 69.78 28.27 123.27 78Q806-724 839.5-656.5 873-589 879-512q1 13-8 22.5t-22 9.5q-13 0-22-9t-10-22q-3-33-12-65.5T780.93-638L417-274q20 25 42.5 46t49.5 38q17 10 22 29.5t-2 39.5q-6 18-24 29.5T464-80Zm-81-245 365-365q-14-17-30-32t-33-29L351-417q5 25 13 47.5t19 44.5Zm-38-170 288-289q-12-6-24-11t-25-9q-101 31-167.5 115.5T345-495Zm-205 15.08Q140-340 237.5-241T475-140q-86-54-138-142.5T285-480q0-109 52.5-197.5T476-820q-140 2-238 100.5t-98 239.58ZM589-497Z"
		/>
	</svg>
);
